var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.375H7.5V7.875H8.25C8.4625 7.875 8.64062 7.80312 8.78437 7.65937C8.92812 7.51562 9 7.3375 9 7.125V6.375C9 6.1625 8.92812 5.98437 8.78437 5.84062C8.64062 5.69687 8.4625 5.625 8.25 5.625H6.75V9.375ZM7.5 7.125V6.375H8.25V7.125H7.5ZM9.75 9.375H11.25C11.4625 9.375 11.6406 9.30312 11.7844 9.15937C11.9281 9.01562 12 8.8375 12 8.625V6.375C12 6.1625 11.9281 5.98437 11.7844 5.84062C11.6406 5.69687 11.4625 5.625 11.25 5.625H9.75V9.375ZM10.5 8.625V6.375H11.25V8.625H10.5ZM12.75 9.375H13.5V7.875H14.25V7.125H13.5V6.375H14.25V5.625H12.75V9.375ZM6 13.5C5.5875 13.5 5.23437 13.3531 4.94062 13.0594C4.64687 12.7656 4.5 12.4125 4.5 12V3C4.5 2.5875 4.64687 2.23437 4.94062 1.94062C5.23437 1.64687 5.5875 1.5 6 1.5H15C15.4125 1.5 15.7656 1.64687 16.0594 1.94062C16.3531 2.23437 16.5 2.5875 16.5 3V12C16.5 12.4125 16.3531 12.7656 16.0594 13.0594C15.7656 13.3531 15.4125 13.5 15 13.5H6ZM6 12H15V3H6V12ZM3 16.5C2.5875 16.5 2.23437 16.3531 1.94062 16.0594C1.64687 15.7656 1.5 15.4125 1.5 15V4.5H3V15H13.5V16.5H3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ceb8eeaeaa1e0487bf0e5c8d6e52a382.svg";
export { ForwardRef as ReactComponent };